import _asyncToGenerator from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './Reminder.css';
import React, { useRef, useState, useEffect, useMemo, createRef } from 'react';
import { createPortal } from 'react-dom';
import Select from 'react-select';
import Flatpickr from 'react-flatpickr';
import { Arabic } from 'flatpickr/dist/l10n/ar.js';
import { Russian } from 'flatpickr/dist/l10n/ru.js';
import { Czech } from 'flatpickr/dist/l10n/cs.js';
import { Dutch } from 'flatpickr/dist/l10n/nl.js';
import { Finnish } from 'flatpickr/dist/l10n/fi.js';
import { German } from 'flatpickr/dist/l10n/de.js';
import { Japanese } from 'flatpickr/dist/l10n/ja.js';
import { Norwegian } from 'flatpickr/dist/l10n/no.js';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import { Swedish } from 'flatpickr/dist/l10n/sv.js';
import { Mandarin } from 'flatpickr/dist/l10n/zh.js';
import { Danish } from 'flatpickr/dist/l10n/da.js';
import { French } from 'flatpickr/dist/l10n/fr.js';
import { Italian } from 'flatpickr/dist/l10n/it.js';
import { Korean } from 'flatpickr/dist/l10n/ko.js';
import { Polish } from 'flatpickr/dist/l10n/pl.js';
import { Romanian } from 'flatpickr/dist/l10n/ro.js';
import { Spanish } from 'flatpickr/dist/l10n/es.js';
import { Ukrainian } from 'flatpickr/dist/l10n/uk.js';
import { Turkish } from 'flatpickr/dist/l10n/tr.js';
import { useSitecoreContext } from '../../../utils/SitecoreContextReactContext';
import { Text, RichText } from '@sitecore-jss/sitecore-jss-react';
import { getColorByTheme, getPageThemeColors, get, getGlobalDictionaryTerm, canUseDOM } from '../../../utils';
/* import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium'; */

import { ReactComponent as ReminderIcon } from '../../../resources/icons/icon-reminder.svg';
import { ReactComponent as PlusIcon } from '../../../resources/icons/icon-plus-round.svg';
import { ReactComponent as MinusIcon } from '../../../resources/icons/icon-minus-round.svg';
import { ReactComponent as CloseConfirm } from '../../../resources/icons/close-tag.svg';
import { ReactComponent as IconChevronDown } from '../../../resources/icons/IconChevronDown.svg';
import { ReactComponent as IconEnvelope } from '../../../resources/icons/icon-envelope.svg';
/* import { ReactComponent as IconWhatsapp }from '../../../resources/icons/icon-whatsapp.svg'; */
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
import { BASE_SINGLE_SELECT_PROPS } from '../../../utils/constants';
import { differenceInDays } from 'date-fns';
import Recaptcha from '../../Login/components/Recaptcha';
var reactSelectSingleUiSettings = BASE_SINGLE_SELECT_PROPS;
var reminderInitialWizardState = {
  remindPanelVisible: false,
  showReminderDateVariants: false,
  showReminderDatePicker: false,
  loading: false,
  dateType: '',
  date: '',
  reminderMode: 'email',
  reminderDataEmail: '',
  reminderDataTextPhone: '',
  reminderDataCountryCode: '',
  emailFieldValid: false,
  phoneFieldValid: false,
  consentCheckBoxValue: false
};
var Reminder = function Reminder(_ref) {
  var lang = _ref.lang,
    event = _ref.event,
    _ref$countryItems = _ref.countryItems,
    countryItems = _ref$countryItems === void 0 ? [] : _ref$countryItems,
    themeValues = _ref.themeValues,
    _ref$hidableMode = _ref.hidableMode,
    hidableMode = _ref$hidableMode === void 0 ? true : _ref$hidableMode,
    _ref$modeFeatured = _ref.modeFeatured,
    modeFeatured = _ref$modeFeatured === void 0 ? false : _ref$modeFeatured,
    _ref$modeSlider = _ref.modeSlider,
    modeSlider = _ref$modeSlider === void 0 ? false : _ref$modeSlider,
    location = _ref.location,
    eventDetail = _ref.eventDetail,
    externalSuccessCallback = _ref.externalSuccessCallback,
    eventsAnalytics = _ref.eventsAnalytics,
    params = _ref.params,
    reminderAccordionStateValue = _ref.reminderAccordionStateValue,
    setIsOpenReminderCalendarPicker = _ref.setIsOpenReminderCalendarPicker,
    numberOfDaysBeforeEventEnd = _ref.numberOfDaysBeforeEventEnd,
    numberOfDaysBeforeEventStart = _ref.numberOfDaysBeforeEventStart,
    setReminderAccordionState = _ref.setReminderAccordionState,
    _ref$isEventBlur = _ref.isEventBlur,
    isEventBlur = _ref$isEventBlur === void 0 ? false : _ref$isEventBlur,
    eventStarted = _ref.eventStarted,
    userProfile = _ref.userProfile;
  var eventAnalyticsTitle = get(event, 'englishTitle', get(event, 'title'));
  var sitecoreContext = useSitecoreContext();
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var setReminderLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderSetReminder') || 'Remind me';
  var setReminderConfirmLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderSuccessMessage') || 'Reminder Has Been Set';
  /* const editLabel: string = getGlobalDictionaryTerm(sitecoreContext, 'ReminderEdit') || ''; */
  var selectDateLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderSelectDate') || 'Select Date test';
  var calendarHeaderLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderCalendarHeader') || 'When should we remind you?';
  var chooseDateLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderChooseDate') || 'Choose date';
  var dayPriorLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderOneDayPrior') || '1 day prior test';
  var weekPriorLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderOneWeekPrior') || '1 week prior test';
  var setReminderIntroLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderEventReminderText') || '"You have the option to set up a timely reminder for this item. An email will be sent to your inbox as a reminder"';
  /* const whatsAppLabel: string = getGlobalDictionaryTerm(sitecoreContext, 'ReminderWhatsApp') || ''; */
  var emailLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderEmail') || 'Email';
  /* const updateLabel: string = getGlobalDictionaryTerm(sitecoreContext, 'ReminderUpdate') || ''; */
  var whatsAppPlaceholderLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderWhatsAppPlaceholder') || '12345678';
  var emailPlaceholderLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderEmailPlaceholder') || 'Email address';
  var doneLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderDone') || 'Done';
  var clearAllLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderClearAll') || 'Clear all';
  var checkBoxLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderConsentBox') || '';
  var PrivacyNoticeLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderPrivacyNotice') || '';
  var recaptchErrorMessage = getGlobalDictionaryTerm(sitecoreContext, 'FieldErrorRequiredRecaptcha') || '';
  var fp = /*#__PURE__*/createRef();
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isVdsite = _useState2[0],
    setIsVdsite = _useState2[1];
  var _useState3 = useState(reminderInitialWizardState),
    _useState4 = _slicedToArray(_useState3, 2),
    remindState = _useState4[0],
    setRemindState = _useState4[1];
  var _useState5 = useState(canUseDOM && document.getElementById('event-remind-confirmations-wrapper')),
    _useState6 = _slicedToArray(_useState5, 1),
    confirmationsContainer = _useState6[0];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showRemindConfirmationMessage = _useState8[0],
    setShowRemindConfirmationMessage = _useState8[1];
  var confirmReminderMessage = useRef(null);
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    highLightEmail = _useState0[0],
    setHighLightEmail = _useState0[1];
  var clickedEmailRef = useRef(false);
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    dropOpened = _useState10[0],
    setDropOpened = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    highLightPhoneText = _useState12[0],
    setHighLightPhoneText = _useState12[1];
  var clickedPhoneTextRef = useRef(false);
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    recaptchaError = _useState14[0],
    setRecaptchaError = _useState14[1];
  var dropFocusStampRef = useRef(0);
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    highLightDrop = _useState16[0],
    setHighLightDrop = _useState16[1];
  var _useState17 = useState({
      label: null,
      value: ''
    }),
    _useState18 = _slicedToArray(_useState17, 2),
    preselectedValue = _useState18[0],
    setPreselectedValue = _useState18[1];
  var _useState19 = useState(null),
    _useState20 = _slicedToArray(_useState19, 2),
    dpSelectedDate = _useState20[0],
    setDpSelectedDate = _useState20[1];
  var colorSettings = useMemo(function () {
    if (themeValues) {
      return {
        '--component-background-color': themeValues[0],
        '--component-color': themeValues[1]
      };
    }
    return {
      '--component-background-color': primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
      '--component-color': getColorByTheme(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary)
    };
  }, [themeValues, isVdsite, primaryPageThemeColor]);
  var _useState21 = useState(true),
    _useState22 = _slicedToArray(_useState21, 2),
    showDropDownOptionChooseDate = _useState22[0],
    setShowDropDownOptionChooseDate = _useState22[1];
  var recaptchaRef = useRef(null);
  var showReminderPanelHandler = function showReminderPanelHandler(event) {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['SetReminderOpenClickAnalytics'], params), "".concat(eventAnalyticsTitle, " : ").concat(eventDetail ? 'event detail' : 'event listing'));
    setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
      remindPanelVisible: !remindState.remindPanelVisible,
      showReminderDatePicker: false
    }));
  };
  var handleEmailBlur = function handleEmailBlur() {
    clickedEmailRef.current = false;
    setHighLightEmail(false);
  };
  var handleEmailMousedown = function handleEmailMousedown() {
    clickedEmailRef.current = true;
  };
  var handleEmailFocus = function handleEmailFocus() {
    if (!clickedEmailRef.current) {
      setHighLightEmail(true);
    }
  };
  var handleEmailInput = function handleEmailInput(e) {
    var target = e.target;
    setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
      emailFieldValid: target.validity.valid,
      reminderDataEmail: target.value
    }));
  };
  var handlePhoneTextMousedown = function handlePhoneTextMousedown() {
    clickedPhoneTextRef.current = true;
  };
  var handlePhoneTextFocus = function handlePhoneTextFocus() {
    if (!clickedPhoneTextRef.current) {
      setHighLightPhoneText(true);
    }
  };
  var handlePhoneTextBlur = function handlePhoneTextBlur() {
    clickedPhoneTextRef.current = false;
    setHighLightPhoneText(false);
  };
  var handlePhoneTextInput = function handlePhoneTextInput(e) {
    var target = e.target;
    setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
      phoneFieldValid: target.validity.valid,
      reminderDataTextPhone: target.value
    }));
  };
  var handleDropMousedown = function handleDropMousedown() {
    if (Date.now() - dropFocusStampRef.current < 10) {
      setHighLightDrop(false);
    }
    setDropOpened(!dropOpened);
  };
  var handleDropTouchstart = function handleDropTouchstart(e) {
    var dropListTouched = !!e.target.closest('.select-dropdown__menu');
    if (!dropListTouched) {
      setDropOpened(!dropOpened);
    }
  };
  var handleDropFocus = function handleDropFocus() {
    dropFocusStampRef.current = Date.now();
    setHighLightDrop(true);
  };
  var handleDropBlur = function handleDropBlur() {
    setDropOpened(false);
    setHighLightDrop(false);
  };
  var handleDropKeyDown = function handleDropKeyDown(e) {
    if (e.which === 13 || e.which === 32) {
      setDropOpened(!dropOpened);
      if (!dropOpened) {
        e.preventDefault();
      }
    }
    if (e.which === 27) {
      setDropOpened(false);
    }
  };
  var handleDropChange = function handleDropChange(e) {
    setDropOpened(false);
    setHighLightDrop(false);
    setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
      reminderDataCountryCode: e.value
    }));
  };
  var rawCountryItems = useMemo(function () {
    var countryItemsList = _toConsumableArray(countryItems);
    return countryItemsList.map(function (country, index) {
      var flagUrl = get(country, 'flag.jss.value.src') || '';
      var flagAlt = get(country, 'flag.jss.value.alt') || '';
      var countryName = get(country, 'countryName.jss.value') || '';
      var countryCode = get(country, 'countryCode.jss.value') || '';
      var phoneCode = get(country, 'phoneCode.jss.value') || '';
      return {
        label: /*#__PURE__*/React.createElement("span", {
          className: "select-item"
        }, flagUrl && !!flagUrl.length && /*#__PURE__*/React.createElement("img", {
          alt: flagAlt,
          className: "select-item__image",
          src: "/".concat(flagUrl)
        }), ' ', /*#__PURE__*/React.createElement("span", {
          className: "select-item__text"
        }, phoneCode || '-')),
        listingLabel: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, countryName), " ", "(".concat(phoneCode || '-', ")")),
        value: phoneCode || "".concat(index, "-"),
        code: countryCode,
        countryName: countryName
      };
    });
  }, []);
  var renderEngineInput = function renderEngineInput() {
    return {
      email: /*#__PURE__*/React.createElement("input", {
        pattern: ".+@.+\\..+",
        className: "mb-0 ".concat(highLightEmail ? 'input-text-primary--focused' : ''),
        type: "email",
        placeholder: emailPlaceholderLabel,
        onMouseDown: handleEmailMousedown,
        onFocus: handleEmailFocus,
        onClick: function onClick() {
          tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['SetEmailWhatsappReminderAnalytics'], params), [eventAnalyticsTitle, "".concat(remindState.reminderMode, " text field")]);
        },
        onBlur: handleEmailBlur,
        onChange: handleEmailInput,
        value: remindState.reminderDataEmail,
        required: true
      }),
      whatsapp: /*#__PURE__*/React.createElement("div", {
        className: "events__reminder-engine-whatsapp-wrapper ".concat(dropOpened ? 'events__reminder-engine-whatsapp-wrapper--opened' : '')
      }, /*#__PURE__*/React.createElement("div", {
        className: "dropdown-wrapper",
        onMouseDown: handleDropMousedown,
        onTouchStart: handleDropTouchstart
      }, /*#__PURE__*/React.createElement(Select, _extends({}, reactSelectSingleUiSettings, {
        name: "code-for-event-".concat(event.objectID),
        options: rawCountryItems,
        defaultValue: remindState.reminderDataCountryCode ? rawCountryItems.find(function (item) {
          return item.value === remindState.reminderDataCountryCode;
        }) : preselectedValue,
        className: "react-custom-select ".concat(highLightDrop ? 'react-custom-select--outlined' : ''),
        onKeyDown: handleDropKeyDown,
        onFocus: handleDropFocus,
        onBlur: handleDropBlur,
        onChange: handleDropChange,
        menuIsOpen: dropOpened,
        "aria-label": event.title,
        "aria-labelledby": event.title,
        formatOptionLabel: function formatOptionLabel(option, _ref2) {
          var context = _ref2.context;
          return context === 'menu' ? option.listingLabel : option.label;
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "events__reminder-engine-whatsapp-spacer"
      }), /*#__PURE__*/React.createElement("input", {
        className: "mb-0 ".concat(highLightPhoneText ? 'input-text-primary--focused' : ''),
        type: "number",
        placeholder: whatsAppPlaceholderLabel,
        maxLength: 20,
        onMouseDown: handlePhoneTextMousedown,
        onFocus: handlePhoneTextFocus,
        onBlur: handlePhoneTextBlur,
        onChange: handlePhoneTextInput,
        value: remindState.reminderDataTextPhone,
        required: true
      }))
    }[remindState.reminderMode];
  };
  var clearDatepicker = function clearDatepicker() {
    setDpSelectedDate(null);
    if (fp && fp.current && fp.current.flatpickr) {
      fp.current.flatpickr.clear();
    }
  };
  var reminderSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var engineValues, oADStartDate, startDateFormatted, data, recaptchaToken, dataToSend, apiCallUrl, formattedDate;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (!remindState.loading) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
              loading: true
            }));
            engineValues = {
              email: {
                Email: remindState.reminderDataEmail
              },
              whatsapp: {
                PhoneNumber: "".concat(remindState.reminderDataCountryCode).concat(remindState.reminderDataTextPhone)
              }
            };
            oADStartDate = get(event, 'startDate');
            /* Offer and deal listing/details page case */
            if (oADStartDate) {
              startDateFormatted = oADStartDate.split('T')[0];
            }
            /* Event details page case */
            if (eventDetail) {
              startDateFormatted = "".concat(event.detailEventDateStart, " ").concat(remindersAvailability.eventStartTime);
            }
            /* Event listing page case */
            if (event.datesRange) {
              startDateFormatted = "".concat(get(event, 'datesRange.from_formatted'), " ").concat(remindersAvailability.eventStartTime);
            }
            data = {
              EventDefinitionKey: get(sitecoreContext, 'configuration.salesforce.reminderEventDefinitionKey') || 'APIEvent-925c5418-c937-6df5-6b25-9b1c54267510',
              FirstName: userProfile && userProfile.firstName,
              LastName: userProfile && userProfile.lastName,
              Country: cachedCookieCountry,
              InterestedIn: '',
              OptinEconomyAndTourism: 'true',
              OptinEsportsAndGames: 'true',
              EventImageURL: event.image,
              DateOfReminder: remindState.date,
              ReminderType: remindState.reminderMode,
              UserDomain: document && document.location && document.location.host,
              Source: '',
              EventId: event.objectID,
              EventTitle: event.title,
              EventDescription: event.introText || event.info,
              EventStartDate: startDateFormatted,
              EventTime: remindersAvailability.eventStartTime,
              EventLocation: location || (Array.isArray(event.location) ? event.location.join() : event.location),
              EventUrl: event.url,
              EventCategory: event.category && Array.isArray(event.category) ? event.category.join() : event.category,
              Language: lang.toUpperCase(),
              Consent: remindState.consentCheckBoxValue
            };
            if (!recaptchaRef.current) {
              _context.n = 3;
              break;
            }
            _context.n = 2;
            return recaptchaRef.current.getRecaptchaToken();
          case 2:
            recaptchaToken = _context.v;
          case 3:
            if (!recaptchaToken) {
              setRecaptchaError(recaptchErrorMessage);
            } else {
              setRecaptchaError('');
            }
            dataToSend = _objectSpread(_objectSpread(_objectSpread({}, data), engineValues[remindState.reminderMode]), {}, {
              grecaptcharesponse: recaptchaToken
            });
            apiCallUrl = '/api/salesforceapi/setreminder';
            if (confirmReminderMessage.current !== null) {
              clearTimeout(confirmReminderMessage.current);
            }
            setShowRemindConfirmationMessage(false);
            setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
              loading: true,
              remindPanelVisible: false
            }));
            _context.n = 4;
            return fetch(apiCallUrl, {
              headers: {
                'Content-Type': 'application/json; charset=utf-8'
              },
              method: 'POST',
              body: JSON.stringify(dataToSend)
            }).then(function (res) {
              if (res.status === 200) return res.text();
            }).then(function (response) {
              if (typeof response === 'string' && response === 'true') {
                var confirmMessages = confirmationsContainer && confirmationsContainer.querySelectorAll('.events__reminder-confirm');
                if (confirmMessages && confirmMessages.length) {
                  confirmMessages.forEach(function (message) {
                    message.style.display = 'none';
                  });
                }
                setShowRemindConfirmationMessage(true);
                setRemindState(_objectSpread(_objectSpread({}, reminderInitialWizardState), {}, {
                  reminderDataEmail: userProfile && userProfile.email,
                  emailFieldValid: !!userProfile
                }));
                if (externalSuccessCallback) {
                  externalSuccessCallback();
                }
                confirmReminderMessage.current = setTimeout(function () {
                  setShowRemindConfirmationMessage(false);
                }, 5000);
              } else {
                console.error('SF request returned false');
                setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
                  loading: false,
                  remindPanelVisible: true
                }));
              }
            }).catch(function (e) {
              setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
                loading: false,
                remindPanelVisible: true
              }));
              console.error(e);
            });
          case 4:
            formattedDate = new Date(dataToSend.DateOfReminder).toLocaleDateString('en-GB', {
              day: 'numeric',
              month: 'long',
              year: 'numeric'
            }).replace(/ /g, '-');
            tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['SetReminderSumbitClickAnalytics'], params), [eventAnalyticsTitle, formattedDate, remindState.reminderMode]);
          case 5:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function reminderSubmit() {
      return _ref3.apply(this, arguments);
    };
  }();

  /* The object with available dates of reminders */
  var remindersAvailability = useMemo(function () {
    /*Start date for Event*/
    var getEventStartDate = function getEventStartDate(fn) {
      /* Event details page case */
      if (eventDetail) {
        if (Object.keys(event).length) {
          /* eventStartDate = Date.parse(`${event.detailEventDateStart} ${event.detailEventTimeStart}`); */
          return Date.parse("".concat(event.detailEventDateStart, " 00:00"));
        }
      }

      /* Event listing page case */
      if (event.eventNextAvailableDate || event.datesRange) {
        var nextAvDate = event.eventNextAvailableDate;
        if (nextAvDate) {
          var dateTSplitted = nextAvDate.split('T');
          return Date.parse(dateTSplitted[0]);
        } else {
          return event.datesRange && event.datesRange.from * 1000;
        }
      }
    };

    /*Start date for OfferAndDeal*/
    var getOADStartDate = function getOADStartDate(fn) {
      return event.startDate_s * 1000;
    };
    setRemindState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        remindPanelVisible: false
      });
    });
    var eventStartDate;
    if (event.showRuleIsHide && event.showRuleShowStartDate_s) {
      eventStartDate = event.showRuleShowStartDate_s * 1000;
    } else {
      var eventType = event && event.type && event.type[0];
      eventStartDate = {
        Event: getEventStartDate(),
        'Offer And Deal': getOADStartDate()
      }[eventType] || 0;
    }
    var eventDetailEventDateStart = new Date(event.detailEventDateStart);
    var numberOfDaysBeforeEventStart = differenceInDays(new Date(), eventDetailEventDateStart);
    var eventStarted = numberOfDaysBeforeEventStart >= 0 ? true : false;
    var lastPossibleDateForOneReminder = new Date(eventStartDate);
    lastPossibleDateForOneReminder.setDate(new Date(eventStartDate).getDate() - 1);
    var lastPossibleDateForSevenReminder = new Date(eventStartDate);
    lastPossibleDateForSevenReminder.setDate(new Date(eventStartDate).getDate() - 7);
    var tomorrowMidnight = new Date().setUTCHours(24, 0, 0, 0);
    var reminder1Stamp = lastPossibleDateForOneReminder.getTime();
    var reminder7Stamp = lastPossibleDateForSevenReminder.getTime();
    var nowStamp = Date.now();
    var eventDateEndStamp = new Date(event.detailEventDateEnd).getTime();
    var oneDayInMilliseconds = 24 * 60 * 60 * 1000;
    return {
      ability1: nowStamp < reminder1Stamp,
      ability7: nowStamp < reminder7Stamp,
      abilityDatePicker: nowStamp < reminder1Stamp,
      datePickerEnd: eventDetail && eventStarted ? eventDateEndStamp - oneDayInMilliseconds : reminder1Stamp,
      datePickerStart: tomorrowMidnight,
      eventActualStamp: eventStartDate,
      functionalityAvailable: nowStamp < reminder1Stamp,
      now: nowStamp,
      reminder1Stamp: reminder1Stamp,
      reminder7Stamp: reminder7Stamp,
      eventStartTime: event.detailEventTimeStart ? event.detailEventTimeStart.slice(0, 5) : '00:00'
    };
  }, [event, eventDetail]);

  /* Get default phonecode by cookie session */
  var cachedCookieCountry = useMemo(function () {
    var countryCode = 'AE';
    if (canUseDOM) {
      var countryNameCookie = document.cookie.split(';').find(function (item) {
        return item.indexOf('user_country_code') > -1;
      });
      if (countryNameCookie) {
        var countryName = countryNameCookie.replace('user_country_code=', '').trim();
        countryCode = countryName !== 'undefined' ? countryName.replace(/\s/g, '') : '';
      }
      if (process.env.STORYBOOK_MODE) {
        countryCode = 'PK';
      }
    }
    return countryCode;
  }, []);
  useEffect(function () {
    if (canUseDOM) {
      var predefinedWizardValues = {};

      /* Get cookie country */
      var countryCode = cachedCookieCountry;
      var serverCountry = rawCountryItems.find(function (item) {
        return item.code === countryCode;
      }) || rawCountryItems[0] || {};
      predefinedWizardValues.reminderDataCountryCode = serverCountry.value;
      setPreselectedValue(serverCountry);

      /* Get default email, if user loggedin */
      var user = userProfile;
      if (user) {
        predefinedWizardValues.emailFieldValid = true;
        predefinedWizardValues.reminderDataEmail = user.email;
      }

      /* Set values */
      setRemindState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), predefinedWizardValues);
      });
    }
  }, [cachedCookieCountry, rawCountryItems, userProfile]);

  /* Clear timeout of confirmation message */
  useEffect(function () {
    return function () {
      if (confirmReminderMessage.current !== null) {
        clearTimeout(confirmReminderMessage.current);
      }
    };
  }, []);

  /* Clear timeout of confirmation message */
  useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  useEffect(function () {
    if (canUseDOM && window.location.search) {
      var value = new URLSearchParams(window.location.search).get('reminder');
      var shouldShowDropDownOptionChooseDate = numberOfDaysBeforeEventEnd && typeof numberOfDaysBeforeEventEnd === 'number' && numberOfDaysBeforeEventEnd !== 2 || event.numberOfDaysBeforeEventEnd && event.numberOfDaysBeforeEventEnd !== 2 || value && value !== '2';
      setShowDropDownOptionChooseDate(shouldShowDropDownOptionChooseDate);
    }
  }, [numberOfDaysBeforeEventEnd, event.numberOfDaysBeforeEventEnd]);
  useEffect(function () {
    if (reminderAccordionStateValue === 'email') setRemindState(reminderInitialWizardState);
  }, [reminderAccordionStateValue]);
  var currentLocale = useMemo(function () {
    var langHash = {
      ar: Arabic,
      ru: Russian,
      cs: Czech,
      nl: Dutch,
      fi: Finnish,
      de: German,
      ja: Japanese,
      no: Norwegian,
      pt: Portuguese,
      sv: Swedish,
      zh: Mandarin,
      da: Danish,
      fr: French,
      it: Italian,
      ko: Korean,
      pl: Polish,
      ro: Romanian,
      es: Spanish,
      uk: Ukrainian,
      tr: Turkish
    };
    return langHash[lang];
  }, [lang]);
  var reminderSubmitDisabled = !remindState.date || !(remindState.reminderMode === 'whatsapp' && remindState.phoneFieldValid || remindState.reminderMode === 'email' && remindState.emailFieldValid);
  return /*#__PURE__*/React.createElement("div", {
    style: colorSettings,
    className: "\n        date-selector__picker\n        ".concat(dpCommonStyles, "\n        ").concat(rtl ? dpRtlStyles : dpLtrStyles, "\n        ").concat(commonStyles, "\n        ").concat(rtl ? rtlStyles : ltrStyles, "\n      ")
  }, /*#__PURE__*/React.createElement("div", {
    className: "events__reminder-item ".concat(remindState.showReminderDatePicker ? 'events__reminder-item-fix' : '', " ")
  }, hidableMode && /*#__PURE__*/React.createElement("button", {
    className: "\n              events__reminder-cta btn--reset\n              ".concat(remindState.remindPanelVisible ? 'events__reminder-cta--hidden' : '', "\n              ").concat(modeFeatured ? 'events__reminder-cta--desk-visible' : '', "\n              ").concat(!modeSlider ? 'events__reminder-cta--desk-visible' : '', "\n\n            "),
    onClick: function onClick() {
      if (!isEventBlur && (typeof numberOfDaysBeforeEventEnd === 'number' && (numberOfDaysBeforeEventEnd === 1 || numberOfDaysBeforeEventEnd === 2) || eventStarted || typeof numberOfDaysBeforeEventStart === 'number' && (numberOfDaysBeforeEventStart === 1 || numberOfDaysBeforeEventStart === 2))) {
        window.location.href = "".concat(event.url).concat(numberOfDaysBeforeEventEnd === 1 || numberOfDaysBeforeEventStart === 1 ? '?reminder=1' : '?reminder=2').concat(eventStarted ? '&eventstarted=true' : '');
        setReminderAccordionState && (numberOfDaysBeforeEventEnd === 1 || event.numberOfDaysBeforeEventEnd === 1) && setReminderAccordionState(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            isEmailBlockHidden: true
          });
        });
      } else {
        showReminderPanelHandler(event);
        setReminderAccordionState && setReminderAccordionState(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            isEmailBlockHidden: false
          });
        });
      }
    },
    disabled: isEventBlur ? remindState.loading || !remindersAvailability.ability1 : remindState.loading || event.numberOfDaysBeforeEventEnd <= 0 || typeof numberOfDaysBeforeEventEnd === 'number' && numberOfDaysBeforeEventEnd <= 0 || typeof numberOfDaysBeforeEventEnd === 'string' && numberOfDaysBeforeEventEnd === 'datesRange is not provided'
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(ReminderIcon, {
    className: "icon-calendar"
  }), " ", setReminderLabel), /*#__PURE__*/React.createElement("span", {
    className: "events__reminder-close-opened"
  }, /*#__PURE__*/React.createElement(PlusIcon, {
    className: "icon-inerraction"
  }))), (remindState.remindPanelVisible || !hidableMode) && /*#__PURE__*/React.createElement("div", {
    className: "\n              events__reminder-panel\n              ".concat(eventDetail ? 'events__reminder-panel--detailviewed' : '', "\n              ").concat(modeFeatured ? 'events__reminder-panel--positioned' : '', "\n              ").concat(!modeSlider ? 'events__reminder-panel--positioned' : '', "\n              ").concat(!hidableMode && remindState.showReminderDatePicker ? 'events__reminder-panel--height-reserved' : '', "\n            ")
  }, hidableMode && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "events__reminder-cta"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(ReminderIcon, {
    className: "icon-calendar"
  }), " ", setReminderLabel), /*#__PURE__*/React.createElement("button", {
    className: "events__reminder-close-opened btn--reset",
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['SetReminderCloseClickAnalytics'], params), eventAnalyticsTitle);
      setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
        remindPanelVisible: !remindState.remindPanelVisible
      }));
    }
  }, /*#__PURE__*/React.createElement(MinusIcon, {
    className: "icon-inerraction"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "events__reminder-intro"
  }, setReminderIntroLabel)), remindState.showReminderDatePicker === false && /*#__PURE__*/React.createElement("div", {
    className: "events__reminder-steps-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "events__reminder-dd-wrapper ".concat(remindState.showReminderDateVariants ? 'events__reminder-dd-wrapper--opened' : '')
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn--reset events__reminder-dd-btn",
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['SelectReminderDateAnalytics'], params), [get(event, 'englishTitle', get(event, 'title')), remindState.showReminderDateVariants ? 'close' : 'open']);
      setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
        dateType: reminderInitialWizardState.dateType,
        date: reminderInitialWizardState.date,
        showReminderDateVariants: !remindState.showReminderDateVariants
      }));
    }
  }, remindState.dateType || selectDateLabel, " ", /*#__PURE__*/React.createElement(IconChevronDown, {
    className: "icon"
  })), remindState.showReminderDateVariants && /*#__PURE__*/React.createElement("ul", {
    className: "events__reminder-dd-variants-list"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      var dateString = new Date(remindersAvailability.reminder1Stamp).toLocaleDateString('en-CA');
      setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
        dateType: dayPriorLabel,
        /* date: `${dateString} ${remindersAvailability.eventStartTime}`, */
        date: "".concat(dateString, " 00:00"),
        showReminderDateVariants: false,
        showReminderDatePicker: false
      }));
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['SelectReminderDateOptionAnalytics'], params), [eventAnalyticsTitle, dayPriorLabel]);
      setIsOpenReminderCalendarPicker && setIsOpenReminderCalendarPicker(false);
    },
    className: "events__reminder-dd-variant btn--reset"
  }, dayPriorLabel)), (isEventBlur ? remindersAvailability.ability7 : typeof numberOfDaysBeforeEventEnd === 'number' && numberOfDaysBeforeEventEnd > 7 || event.numberOfDaysBeforeEventEnd > 7) && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['SelectReminderDateOptionAnalytics'], params), [eventAnalyticsTitle, weekPriorLabel]);
      var dateString = new Date(remindersAvailability.reminder7Stamp).toLocaleDateString('en-CA');
      setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
        dateType: weekPriorLabel,
        /* date: `${dateString} ${remindersAvailability.eventStartTime}`, */
        date: "".concat(dateString, " 00:00"),
        showReminderDateVariants: false,
        showReminderDatePicker: false
      }));
      setIsOpenReminderCalendarPicker && setIsOpenReminderCalendarPicker(false);
    },
    className: "events__reminder-dd-variant btn--reset"
  }, weekPriorLabel)), showDropDownOptionChooseDate && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['SelectReminderDateOptionAnalytics'], params), [eventAnalyticsTitle, chooseDateLabel]);
      setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
        showReminderDateVariants: false,
        showReminderDatePicker: true
      }));
      setIsOpenReminderCalendarPicker && setIsOpenReminderCalendarPicker(true);
    },
    className: "events__reminder-dd-variant btn--reset"
  }, chooseDateLabel)))), remindState.date && !remindState.showReminderDateVariants && /*#__PURE__*/React.createElement("div", {
    className: "events__reminder-engine-selector"
  }, /*#__PURE__*/React.createElement("button", {
    className: "events__reminder-engine-selector-cta btn--reset ".concat(remindState.reminderMode === 'email' ? 'events__reminder-engine-selector-cta--active' : ''),
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['SetEmailWhatsappReminderAnalytics'], params), [eventAnalyticsTitle, 'email click']);
      setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
        reminderMode: 'email'
      }));
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "events__reminder-engine-selector-cta-text"
  }, /*#__PURE__*/React.createElement(IconEnvelope, {
    className: "icon"
  }), emailLabel))), remindState.date && !remindState.showReminderDateVariants && /*#__PURE__*/React.createElement("div", {
    className: "events__reminder-engine-data"
  }, renderEngineInput()), remindState.date && /*#__PURE__*/React.createElement("div", {
    className: "events__reminder-checkbox-wrapper"
  }, /*#__PURE__*/React.createElement("label", {
    className: "events__reminder-checkbox-label"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    name: "receive-events-updates",
    onChange: function onChange(e) {
      setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
        consentCheckBoxValue: e.target.checked
      }));
    }
  }), /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    field: {
      value: checkBoxLabel
    }
  }))), !remindState.showReminderDateVariants && /*#__PURE__*/React.createElement("div", {
    className: "events__reminder-submit-wrapper"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary",
    onClick: reminderSubmit,
    disabled: reminderSubmitDisabled || remindState.loading
  }, setReminderLabel), /*#__PURE__*/React.createElement(RichText, {
    tag: "div",
    className: "events-reminder-privacy-notice",
    field: {
      value: PrivacyNoticeLabel
    }
  }))), remindState.showReminderDatePicker && /*#__PURE__*/React.createElement("div", {
    className: "events__reminder-dp-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "events__reminder-dp-border"
  }, /*#__PURE__*/React.createElement("div", {
    className: "events__reminder-dp-header"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-link btn-close-calendar",
    onClick: function onClick() {
      setIsOpenReminderCalendarPicker && setIsOpenReminderCalendarPicker(false);
      setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
        showReminderDatePicker: false
      }));
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: "20",
    height: "15",
    viewBox: "0 0 20 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.288,1.37329a2.137,2.137 0 0 0 0.285,2.925l2.436,2.116l-14.009,0l0,1.916l14.009,0l-2.436,2.117a2.137,2.137 0 0 0 -0.285,2.926l6.712,-6l-6.712,-6z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("h5", {
    className: "events__reminder-dp-title"
  }, calendarHeaderLabel), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-link",
    onClick: clearDatepicker
  }, clearAllLabel)), /*#__PURE__*/React.createElement(Flatpickr, {
    ref: fp,
    "aria-label": calendarHeaderLabel,
    options: {
      showMonths: 1,
      allowInput: false,
      mode: 'single',
      minDate: remindersAvailability.datePickerStart,
      maxDate: remindersAvailability.datePickerEnd,
      inline: true,
      locale: lang === 'en' ? 'en' : currentLocale,
      nextArrow: "<svg width=\"20\" height=\"15\" viewBox=\"0 0 20 15\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m12.288,1.37329a2.137,2.137 0 0 0 0.285,2.925l2.436,2.116l-14.009,0l0,1.916l14.009,0l-2.436,2.117a2.137,2.137 0 0 0 -0.285,2.926l6.712,-6l-6.712,-6z\" fill=\"currentColor\"/></svg>",
      prevArrow: "<svg width=\"20\" height=\"15\" viewBox=\"0 0 20 15\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m12.288,1.37329a2.137,2.137 0 0 0 0.285,2.925l2.436,2.116l-14.009,0l0,1.916l14.009,0l-2.436,2.117a2.137,2.137 0 0 0 -0.285,2.926l6.712,-6l-6.712,-6z\" fill=\"currentColor\"/></svg>"
    },
    onChange: function onChange(date) {
      if (date && date.length !== 0) {
        setDpSelectedDate(date[0]);
      }
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "events__reminder-dp-cta"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary",
    disabled: !dpSelectedDate,
    onClick: function onClick() {
      if (dpSelectedDate) {
        var formattedDate = dpSelectedDate.toLocaleDateString('en-GB', {
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        });
        tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['SelectReminderDateValueAnalytics'], params), [eventAnalyticsTitle, formattedDate.replace(/ /g, '-')]);
      }
      var typeMonth = dpSelectedDate ? dpSelectedDate.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short'
      }) : '';
      clearDatepicker();
      setRemindState(_objectSpread(_objectSpread({}, remindState), {}, {
        dateType: typeMonth,
        date: dpSelectedDate ? "".concat(dpSelectedDate.toLocaleDateString('en-CA'), " 00:00") : '',
        showReminderDateVariants: false,
        showReminderDatePicker: false
      }));
    }
  }, doneLabel)))), showRemindConfirmationMessage && confirmationsContainer ? /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement("div", {
    className: "events__reminder-confirm",
    title: event.title
  }, setReminderConfirmLabel, /*#__PURE__*/React.createElement("button", {
    className: "events__reminder-confirm-close btn--reset",
    onClick: function onClick() {
      if (confirmReminderMessage.current !== null) {
        clearTimeout(confirmReminderMessage.current);
      }
      setShowRemindConfirmationMessage(false);
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['CloseNotificationClickAnalytics'], params), [eventAnalyticsTitle, setReminderConfirmLabel]);
    }
  }, /*#__PURE__*/React.createElement(CloseConfirm, {
    className: "icon"
  }))), confirmationsContainer) : null), /*#__PURE__*/React.createElement(Recaptcha, {
    errorMessasge: recaptchaError,
    ref: recaptchaRef
  }));
};
var dpCommonStyles = "dqvuxp6";
var dpRtlStyles = "d77sl8t";
var dpLtrStyles = "d14n39i4";
var commonStyles = "cib6kfb";
var ltrStyles = "l9o4w1x";
var rtlStyles = "r5stag7";
export default Reminder;